import { Box, Paper, TextareaAutosize } from '@mui/material';
import { Field, Form } from 'react-final-form';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import { useChatMessagesContext } from '../../../../../../contexts/chatMessages.context';
import { useChatMessageFormStyles } from './chatMessageForm.styles';
import { messageFormValidate } from './chatMessageForm.utils';
import SendMessageButton from './components/SendMessageButton';

interface ChatMessageFormProps {
  disabled: boolean;
}

const ChatMessageForm = ({ disabled }: ChatMessageFormProps) => {
  const { classes } = useChatMessageFormStyles();

  const { translate } = useTranslation();

  const { submitMessage } = useChatMessagesContext();

  return (
    <label htmlFor="input-message">
      <Paper className={classes.wrapper}>
        <Form
          onSubmit={submitMessage}
          validate={messageFormValidate}
          render={({ handleSubmit, values, form }) => {
            const sendButtonDisabled = !values.messageText || disabled;

            return (
              <form
                onSubmit={async (event) => {
                  await handleSubmit(event);
                  form.reset();
                  form.focus('messageText');
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                  }}
                >
                  <Field name="messageText">
                    {({ input }) => (
                      <TextareaAutosize
                        id="input-message"
                        autoFocus
                        maxRows={3}
                        type="text"
                        disabled={disabled}
                        className={classes.input}
                        placeholder={translate(LangEnum.CHAT_MESSAGES_INPUT_PLACEHOLDER)}
                        onKeyDown={async (event) => {
                          if (event.key === 'Enter' && !disabled) {
                            if (!event.shiftKey) {
                              event.preventDefault();
                              await form.submit();
                              form.reset();
                            }
                          }
                        }}
                        {...input}
                      />
                    )}
                  </Field>

                  <Box
                    sx={{
                      alignSelf: 'flex-end',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <SendMessageButton sendButtonDisabled={sendButtonDisabled} />
                  </Box>
                </Box>
              </form>
            );
          }}
        />
      </Paper>
    </label>
  );
};

export default ChatMessageForm;
